import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TokenContext from './TokenContext';
import { PENDING_AUTHORIZE_KEY } from './Authorize';

function Callback() {
  const { setToken } = useContext(TokenContext);
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      setToken(token);
      const pendingAuthorize = sessionStorage.getItem(PENDING_AUTHORIZE_KEY);
      if (pendingAuthorize) {
        sessionStorage.removeItem(PENDING_AUTHORIZE_KEY);
        navigate(`/authorize?request=${encodeURIComponent(pendingAuthorize)}`);
        return;
      }
      navigate('/banners');
    } 
  }, [setToken, navigate]);

  return (
    <div>
    </div>
  );
}

export default Callback;
